import { Action } from 'redux';

export interface OptInModalAction extends Action {
  readonly isOptInModalOpen?: boolean;
}

export interface OptInModal {
  isOptInModalOpen: boolean;
}

const initialState = {
  isOptInModalOpen: false,
} as OptInModal;

enum Actions {
  OPEN_OPT_IN_MODAL = 'OPEN_OPT_IN_MODAL',
  CLOSE_OPEN_OPT_IN_MODAL = 'CLOSE_OPEN_OPT_IN_MODAL',
}

const openOptInModal = (): OptInModalAction => ({
  type: Actions.OPEN_OPT_IN_MODAL,
});

const closeOptInModal = (): OptInModalAction => ({
  type: Actions.CLOSE_OPEN_OPT_IN_MODAL,
});

const optInReducer = (state = initialState, action: OptInModalAction) => {
  switch (action.type) {
    case Actions.OPEN_OPT_IN_MODAL:
      return {
        ...state,
        isOptInModalOpen: true,
      };
    case Actions.CLOSE_OPEN_OPT_IN_MODAL:
      return {
        ...state,
        isOptInModalOpen: false,
      };
    default:
      return state;
  }
};

export { optInReducer, openOptInModal, closeOptInModal };
